module.exports = __webpack_public_path__ + "static/img/6c-1.117b221.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/6c-1.png
// module id = DZ5m
// module chunks = 0